import React from "react";
import { Helmet } from "react-helmet";

export default function SEO({
  title,
  description,
  canonicalUrl,
  type = "website",
}) {
  return (
    <Helmet>
      {/* 1. STANDARD TAGS */}
      {/* The visible tab title */}
      <title>{title} | NoWastedDays</title>

      {/* The text appearing under your link in Google */}
      <meta name="description" content={description} />

      {/* 2. CANONICAL TAG (Crucial for React) */}
      {/* Tells Google: "This is the master copy of this page" */}
      <link rel="canonical" href={canonicalUrl} />

      {/* 3. OPEN GRAPH (For Facebook, LinkedIn, etc.) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      {/* <meta property="og:image" content={imageUrl} />  <-- Add this if you have specific images */}

      {/* 4. TWITTER CARDS */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
